import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report59Component() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re59data, setRe59data] = useState([]);

    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }

    async function getR59() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res59 = await fetch("/api/Support/getR59", {
            method: 'POST',
            body: formData
        })
        const Re59data = await res59.json()
        setRe59data(Re59data.dataenum);
        console.log(Re59data)
    }

    const [Re59yeardata, setRe59yeardata] = React.useState([]);

    async function getR59year() {
        const res = await fetch("/api/Support/getyear59")
        const Re59yeardata = await res.json()
        setRe59yeardata(Re59yeardata.dataenum)
        console.log(Re59yeardata)
    }


    const y2 = Re59yeardata.filter(n => n.yearTh >= othYearSelected);

    React.useEffect(() => {
        getR59()
        getR59year()
    }, [thYearSelected, othYearSelected]);



  
  

   

    return (
        <Container>
            <div>

                <div style={{ display: 'flex', paddingBottom: '20px' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re59yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/Support/xlsxR59?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/Support/pdfR59?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                    </Col>
                </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                    <Table className="styled-table" bordered striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3">
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                รายการ
                            </th>
                            <th rowSpan="3" className=' text-center'>
                                จำนวนผู้เข้ารับการประเมิน (คน)
                            </th>
                            <th rowSpan="3" className=' text-center'>
                                จำนวนผู้ผ่านการประเมิน (คน)
                            </th>
                            <th colSpan="15" className=' text-center'>
                                จำนวนเงินช่วยเหลือหรืออุดหนุน
                            </th>
                        </tr>
                        <tr>
                            <th colSpan="1" className='text-center'>
                                ค่าตอบแทนผู้ประเมิน (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                ค่าตอบการปฏิบัติงานนอกเวลาราชการ (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                ค่าเดินทางไปราชการทำหน้าที่ผู้ประเมิน (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                ค่าวัสดุใช้ในการประเมิน (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                รวม (บาท)
                            </th>
                           
                        </tr>
                       
                     
                      
                     </thead>

                            <tbody>
                                {Re59data.length > 0 && Re59data.map((item, i) => (
                                    <tr >
                                        <td className='text-center'>
                                            {i+1}
                                        </td>
                                        <td className='text-start'>
                                            {item.list}
                                        </td>
                                        <td className='text-end'>
                                            {item.personTest}
                                        </td>
                                        <td className='text-end'>
                                            {item.passEvaluation}
                                        </td>
                                        <td className='text-end'>
                                            {item.evaluatorExpense}
                                        </td>
                                        <td className='text-end'>
                                            {item.compensationExpense}
                                        </td>

                                        <td className='text-end'>
                                            {item.travellingExpense}
                                        </td>
                                        <td className='text-end'>
                                            {item.materialExpense}
                                        </td>
                                        <td className='text-end'>
                                            {item.sum}
                                        </td>

                                    </tr>

                                )) || <tr><td colSpan="9" rowSpan="6" className='text-center'>No Data</td></tr>}
                                {/*<tr>*/}
                                {/*    <td colSpan="2" className='text-end'>*/}
                                {/*        รวม*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum1}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum2}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum3}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum4}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum5}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum6}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum7}*/}
                                {/*    </td>*/}
                                   

                               {/* </tr>*/}

                            </tbody>


                   
                </Table>
                    </div>
                </div>       
            </div>

        </Container>

       
    )
}